import type { TFormProps } from "@/ui/components/form/Form";
import type { TInputProps } from "@/ui/components/form/Input";
import type { TButtonProps } from "@/ui/components/primitives/Button";
import type { SubmitEventHandler } from "react";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const LOGIN_DEFAULTS = {
  noValidate: true,
} satisfies Pick<TLoginProps, "noValidate">;

export const LOGIN_FIELD_CLASS = "w-full [&_[data-component='Label']]:font-sys-heading [&_[data-component='Label']]:leading-sys-1-3";

export const LOGIN_FORGOT_PASSWORD_LINK_CLASS = "font-sys-display text-sys-base leading-none underline";

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TLoginInputProps = Omit<
  TInputProps,
  | "aria-describedby"
  | "defaultValue"
  | "id"
  | "label"
  | "name"
  | "onBlur"
  | "onChange"
  | "type"
  | "value"
> & {
  value: string;
  onValueChange: (value: string) => void;
  onBlur?: () => void;
  label?: string;
};

export type TLoginSubmitProps = Omit<
  TButtonProps,
  "children" | "type"
> & {
  label?: string;
};

export type TLoginForgotPasswordProps = {
  label?: string;
  href: string;
};

export type TLoginWithPasswordMessages = {
  emailLabel: string;
  emailPlaceholder: string;
  passwordLabel: string;
  passwordPlaceholder: string;
  forgotPasswordLabel: string;
  submitLabel: string;
};

export type TLoginWithPasswordTranslate = (
  key: keyof TLoginWithPasswordMessages,
) => string;

export type TLoginProps = Omit<
  TFormProps,
  "onSubmit"
> & {
  email: TLoginInputProps;
  password: TLoginInputProps;
  submit: TLoginSubmitProps;
  forgotPassword: TLoginForgotPasswordProps;
  onSubmit: SubmitEventHandler<HTMLFormElement>;
};
